export default __webpack_public_path__ + "static/soehne-web-buch-e8cd54bcc7367e7617a437e9b14a7413.woff2";